import React from 'react';
import { Link } from 'react-router-dom';

const SITEMAP = [
  {
    title: 'Main Pages',
    links: [
      { label: 'Home', to: '/' },
      { label: 'Services', to: '/services' },
      { label: 'Government', to: '/government' },
      { label: 'Portfolio', to: '/portfolio' },
      { label: 'Contact Us', to: '/contact' },
    ],
  },
  {
    title: 'Company Info',
    links: [
      { label: 'Overview', to: '/company/overview' },
      { label: 'Our Expertise', to: '/company/expertise' },
      { label: 'Vision & Mission', to: '/company/vision-mission' },
      { label: 'Management Team', to: '/company/management-team' },
      { label: 'Why EGB', to: '/company/why-egb' },
      { label: 'Awards', to: '/company/awards' },
    ],
  },
  {
    title: 'Services',
    links: [
      { label: 'Web Services', to: '/web-services' },
      { label: 'AI Services', to: '/ai-services' },
      { label: 'Our Strategy', to: '/strategy' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'Terms of Use', to: '/terms-of-use' },
      { label: 'Sitemap', to: '/sitemap' },
    ],
  },
];

const Sitemap = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Sitemap</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>All pages on EGB Systems & Solutions website</p>
      </div>
    </section>

    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="row g-4">
          {SITEMAP.map((section, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <h5 className="fw-bold mb-3" style={{ color: '#1a56db' }}>{section.title}</h5>
              <ul className="list-unstyled">
                {section.links.map((link, j) => (
                  <li key={j} className="mb-2">
                    <Link to={link.to} className="text-decoration-none text-muted" style={{ fontSize: 15 }}>
                      → {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Sitemap;
